import {
    Button,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-unresolved
import { SplitButton } from '@commonClient2/components';
import {
    BidProcessType, EmployeeBiddingStatus, ShiftlineSelectionModals, EmployeeShiftLineTemplateAction, ShiftlineFilterSelectionTabs,
} from '../../Enums';
import { getReportOptions } from '../../Employee/services/utilities/reports';

import './BidActions.scss';

/**
 * @param {{
 *  bidProfile: EmployeeBidProfile.IDetailedEmployeeBidProfile,
 *  employeeBidSelection: EmployeeBidSelection.IBidSelectionStore,
 *  setShowReport: Function;
 *  setShowModal: Function;
 *  handleTemplateAction: Function;
 *  isOnBehalf: boolean;
 *  isHideTemplateActionsInUnselectedTab: boolean;
 * }} param0
 */
const BidActions = ({ /** TODO kath 10-03 - #10725 - Put BidActions component in desktop */
    bidProfile,
    employeeBidSelection,
    setShowReport,
    setShowModal,
    handleTemplateAction,
    isOnBehalf,
    isHideTemplateActionsInUnselectedTab = false,
}) => {
    const {
        employeeSubmissionStatus,
        hasTemplate,
        isRebidAllowed,
        bidProcessType,
        isEnableEmployeeBidResultReport,
        isEnableEmployeeRankReport,
        isEmployeeCanDeclineBid,
        employeeRank,
    } = bidProfile;
    const {
        selectionFilters,
        employeeSelections,
    } = employeeBidSelection;
    const { t } = useTranslation('shiftBidding');

    const isShowReports = !isOnBehalf;
    const isSequential = bidProcessType === BidProcessType.Sequential;
    const isPreferential = bidProcessType === BidProcessType.Preferential;
    const isUnsubmitted = employeeSubmissionStatus === EmployeeBiddingStatus.Unsubmitted;
    const employeeSelectionsCount = employeeSelections.length;
    const isUnselectedTab = selectionFilters.selectedTab === ShiftlineFilterSelectionTabs.Unselected;

    /**
     * @type {import("../../components/GroupedIconButton/GroupedIconButton").GroupedIconButtonOption[]}}
     */
    const reportOptions = getReportOptions({
        t, isSequential, isEnableEmployeeRankReport, isEnableEmployeeBidResultReport, setShowReport, employeeId: employeeRank.employeeId,
    });

    return (
        <div className="actions-container">
            {
                isShowReports && !!(reportOptions.length) && (
                    <div className="ba-report-icon-container">
                        <SplitButton
                            className="report-split-button"
                            options={reportOptions}
                            defaultValue={{ label: t('employee.common.viewReports'), value: 0, disabled: false }}
                            color="secondary"
                            handleClick={(
                                /** @type {import("../../components/GroupedIconButton/GroupedIconButton").GroupedIconButtonOption} */ option,
                            ) => setShowReport(option.value)}
                            showChevron={false}
                        />
                    </div>
                )
            }
            {
                isPreferential && isUnsubmitted && (
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setShowModal(ShiftlineSelectionModals.Close)}
                        disabled={employeeSelectionsCount === 0}
                        className="ba-draft-button"
                    >
                        {t('employee.common.close')}
                    </Button>
                )
            }
            {
                isPreferential && isRebidAllowed && !(isHideTemplateActionsInUnselectedTab && isUnselectedTab) && (
                    <>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => handleTemplateAction({ value: EmployeeShiftLineTemplateAction.Save })}
                            disabled={employeeSelectionsCount === 0}
                            className="ba-draft-button"
                        >
                            {t('employee.common.saveTemplate')}
                        </Button>
                        {
                            hasTemplate && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => handleTemplateAction({ value: EmployeeShiftLineTemplateAction.Load })}
                                    className="ba-draft-button"
                                >
                                    {t('employee.common.loadTemplate')}
                                </Button>
                            )
                        }
                    </>
                )
            }
            <Button
                variant="contained"
                color="primary"
                onClick={() => setShowModal(ShiftlineSelectionModals.ConfirmBidSelection)}
                disabled={employeeSelectionsCount === 0}
                className="ba-submit-button"
            >
                {t('employee.shiftlineSelection.submit')}
            </Button>
            {
                isEmployeeCanDeclineBid
                && (
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setShowModal(ShiftlineSelectionModals.DeclineBid)}
                        className="ba-decline-button"
                    >
                        {t('employee.shiftlineSelection.decline')}
                    </Button>
                )
            }
        </div>
    );
};

export default BidActions;
